export default __webpack_public_path__ + "static/media/4383.8c21495a.png";